
const MockTestStartBox =({mockTestCard1Object,setCloseStartBoxPopUp,setCloseInstructionsPopUp})=>{
    return(<>
 <div    onClick={()=>setCloseStartBoxPopUp(false)} className="mockTestV1PopUpStartBoxOpacityStartBox"  style={{cursor:"pointer"}}> </div>
        <div   className="mockTestV1PopUpStartBox" style={{borderRadius: '0px'}}> 
        <h2 align="center" >   <span className="" style={{fontSize:"34px"}} >Test Name & Info </span> </h2>
      
 
<div style={{overflowY:"auto",paddingBottom:"50px",height:"300px"}}>
    

       <div style={{display:"flex",justifyContent:"center"}}></div>
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"10px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>
    <button  onClick={()=>{setCloseStartBoxPopUp(false)}}    className=" MocktestStartBoxBtn"  type="submit"
 > Cancel </button>
<button  onClick={()=>{setCloseStartBoxPopUp(false);setCloseInstructionsPopUp(true)}}   style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" MocktestStartBoxBtn"  type="submit"
 > Next </button>
</div> 
</div></div>
<style>{`



 .mockTestStartBoxTextbox, .mockTestStartBoxTextbox:hover, .mockTestStartBoxTextbox:focus{
    background: #f9f9f9;
    box-shadow:var(--shadow-default);
   color:#222;
   padding: 15px;
   margin:10px;outline: #fff;
   border: 3px solid rgba(144, 202, 249,1) !important;
   border-radius: 10px;;
}
  
.MocktestStartBoxBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  
.mockTestColoredTextV1StartBox {
         animation: background-pan-b24b2865 0.9s linear infinite;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
 
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #8142e3, #86c2ff);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
.mockTestV1PopUpStartBoxOpacityStartBox{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:15px;
        background:rgba(1, 1, 1,0.061);
        z-index:9999999999 !important}
        
        .mockTestV1PopUpStartBox{position:fixed;
    left:0%;
    right:0%;
    background: linear-gradient(to right, #fff,#f5f5f5, #fff, #fff);
    top:0%;bottom:0%;
    padding:15px;
    z-index:99999999999 !important;}

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
    .mockTestV1PopUpStartBox{position:fixed;top:0px;
        left:20%;
        right:20%;top:22%;
       }}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
  .mockTestV1PopUpStartBox{position:fixed;top:0px;
                left:20%;
                right:20%;top:22%;
               }} 

/* xs */
@media (max-width: 767px) {
    
    .mockTestV1PopUpStartBox{
       
        top:0px!important; height:100% !important;
        left:0%;border-radius: 0px !important;
        right:0%;
        bottom:0%!important;
    }
        }
        `}</style>
    </>)
}
export default MockTestStartBox;